<template>
    <div class="contenido">
        <Titulo titulo="SITIOS DE INTERES"
            icono="tierra"
        />

        <b-row class="mt-4">
            <b-col cols="2"></b-col>
            <b-col>
                <b-card
                    no-body class="overflow-hidden mb-2" 
                    style="max-width: 540px;"
                    v-for="sitio in sitios" :key="sitio.id_paginaint"
                >
                    <b-row no-gutters>
                        <b-col md="2">
                            <p class="h1 m-3"><b-icon icon="exclamation-circle-fill"></b-icon></p>
                        </b-col>
                        <b-col md="10">
                            <b-card-body :title="sitio.nombre">
                                <b-card-text>
                                    <small>{{ sitio.descripcion }}</small>
                                </b-card-text>

                                <div class="text-right"><a :href="sitio.pagina" target="_blank" class="card-link">Visitar</a></div>
                            </b-card-body>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
            <b-col></b-col>
        </b-row>
    </div>
</template>

<script>
import Titulo from '@/components/Titulo.vue'
import axios from 'axios'
import {mapState} from 'vuex'

export default {
    name: 'SitiosInteres',
    props: {
    },
    components: {
        Titulo
    },
    data() {
        return {
            sitios: []
        }
    },
    created() {
        var formData = new FormData();
        formData.append("accion", "mostrarDatos");
        formData.append("tabla", "paginas_interes");
        formData.append("ordenamiento", `nombre`);
        
        axios.post(`${this.url}/ajax/ajax.generico.php`, formData)
        .then((res) => {
            this.sitios = res.data
        });
    },
    computed: {
        url() {
            if ( ["localhost", "127.0.0.1", ""].includes(window.location.hostname) ) {
                return this.urlSandbox
            } else {
                return this.urlProd
            }
        },
        ...mapState(['urlProd']),
        ...mapState(['urlSandbox'])
    }
}
</script>

<style scoped>
.contenido{
    min-height: 500px;
}
</style>